<template>
  <el-drawer
    title="详情"
    :visible.sync="drawer"
    :destroy-on-close="true"
    :close-on-press-escape="false"
    :before-close="handleClose"
    size="50%"
    withHeader="false"
  >
    <div class="title-box">基本信息</div>
    <el-descriptions :column="1" style="margin-left: 40px">
      <el-descriptions-item label="活动名称">{{ info.name }}</el-descriptions-item>
      <el-descriptions-item label="隶属公司">{{ info.merchantName }}</el-descriptions-item>
      <el-descriptions-item label="活动时间"
        >{{ info.startTime }} 至 {{ info.endTime }}</el-descriptions-item
      >
    </el-descriptions>
    <div class="title-box">活动奖励</div>
    <el-table
      :data="info.couponInfoList"
      border
      size="mini"
      max-height="280px"
      style="margin: 0 10px"
    >
      <el-table-column label="序号" type="index" width="50" align="center" />
      <el-table-column label="优惠券名称" align="center" prop="couponName" />
      <el-table-column label="所属礼包" align="center" prop="giftName" />
      <el-table-column label="金额/个" align="center" prop="discountsMoney" />
      <el-table-column label="每次领取数量" align="center" prop="num" />
    </el-table>

    <div style="display: flex; align-items: center; margin-bottom: 20px; margin-top: 20px">
      <div class="descriptions-text">生成兑换码：</div>
      <el-descriptions
        :column="4"
        border
        direction="vertical"
        style="width: 200px"
        size="mini"
        :contentStyle="rowCenter"
        :labelStyle="rowCenter"
      >
        <el-descriptions-item label="总量">{{ totalCount }}</el-descriptions-item>
        <el-descriptions-item label="使用">{{ useCount }}</el-descriptions-item>
        <el-descriptions-item label="剩余">{{ suplusCount }}</el-descriptions-item>
        <el-descriptions-item label="作废">{{ cancelCount }}</el-descriptions-item>
      </el-descriptions>
    </div>

    <div class="title-box">其他</div>
    <div class="bottom-box">
      <el-descriptions :column="1" style="margin-left: 40px">
        <el-descriptions-item label="创建人">{{ info.createUser }}</el-descriptions-item>
        <el-descriptions-item label="审核人">{{ info.auditUser }}</el-descriptions-item>
        <el-descriptions-item label="活动状态">{{ info.statusTr }}</el-descriptions-item>
        <el-descriptions-item v-if="info.refuseMsg" label="不通过原因">{{
          info.refuseMsg
        }}</el-descriptions-item>
      </el-descriptions>
      <el-descriptions :column="1">
        <el-descriptions-item label="创建时间">{{ info.createTime }}</el-descriptions-item>
        <el-descriptions-item label="审核时间">{{ info.auditTime }}</el-descriptions-item>
      </el-descriptions>
    </div>
  </el-drawer>
</template>

<script>
  import { getDetail } from '@/api/marketing/coupon-code-redemption'

  export default {
    data() {
      return {
        drawer: false,
        info: {},
        rowCenter: {
          'text-align': 'center'
        }
      }
    },
    computed: {
      totalCount() {
        if (this.info && this.info.activityRedemption) {
          return this.info.activityRedemption.totalCount
        }
        return null
      },
      useCount() {
        if (this.info && this.info.activityRedemption) {
          return this.info.activityRedemption.useCount
        }
        return null
      },
      suplusCount() {
        if (this.info && this.info.activityRedemption) {
          return this.info.activityRedemption.suplusCount
        }
        return null
      },
      cancelCount() {
        if (this.info && this.info.activityRedemption) {
          return this.info.activityRedemption.cancelCount
        }
        return null
      }
    },
    methods: {
      init(id) {
        this.getInfoFetch(id)
      },
      getInfoFetch(id) {
        this.$loading()
        getDetail(id)
          .then((res) => {
            const { code, data } = res
            if (code === 0) {
              this.info = data
              this.drawer = true
            }
          })
          .finally(() => {
            this.$loading().close()
          })
      },
      handleClose() {
        this.title = ''
        this.info = {}
        this.drawer = false
      }
    }
  }
</script>

<style lang="scss" scoped>
  .title-box {
    margin: 0 0 20px 20px;
    font-size: 18px;
    font-weight: 500;
    position: relative;

    &::before {
      content: ' ';
      background-color: #409eff;
      width: 4px;
      height: 100%;
      border-radius: 1px;
      position: absolute;
      left: -10px;
    }
  }

  .bottom-box {
    display: flex;
  }

  .descriptions-text {
    text-align: left;
    font-weight: 400;
    line-height: 1.5;
    font-size: 14px;
    margin-left: 40px;
    margin-bottom: 10px;
  }
  .url-box {
    color: #409eff;
    width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
